import PropTypes from 'prop-types';

import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import LaunchIcon from '@mui/icons-material/Launch';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import RowMenu from '../RowMenu/RowMenu';

import classes from './DataTable.module.css';

const DataTable = ({ data, charges }) => {
  return (
    <div className={classes.dataContainer}>
      <p className={classes.tableTitle}>{data.name}</p>
      <TableContainer className={classes.tableContainer}>
        <Table>
          <TableHead className={classes.tableHeadContainer}>
            <TableRow>
              <TableCell className={classes.cellHeader}>
                Concepto
              </TableCell>
              <TableCell className={classes.cellHeader} />
              <TableCell className={classes.cellHeader}>
                Programa
              </TableCell>
              <TableCell className={classes.cellHeader}>
                {charges ? 'Fecha límite' : 'Fecha del pago'}
              </TableCell>
              <TableCell className={classes.cellHeader}>
                {charges ? 'Monto a pagar' : 'Pago'}
              </TableCell>
              <TableCell className={classes.cellHeader} />
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBodyContainer}>
            {data.payments.map(item => (
              <TableRow key={item.idUserPayment}>
                <TableCell className={classes.cell}>
                  {item.idProduct === '2' ? (
                    <span>Libro {item.concept}</span>
                  ) : item.idProduct === '3' ? (
                    <span>Curso {item.concept}</span>
                  ) : (
                    <span>{item.concept}</span>
                  )}
                </TableCell>
                <TableCell className={classes.cell}>
                  <IconButton component="a" href={item.urlProduct}>
                    <LaunchIcon />
                  </IconButton>
                </TableCell>
                <TableCell className={classes.cell}>
                  {item.program}
                </TableCell>
                <TableCell className={classes.cell}>
                  {item.formatPayDate}
                </TableCell>
                <TableCell className={classes.cell}>
                  ${' '}
                  {new Intl.NumberFormat('en-US').format(
                    item.amount / 100
                  )}{' '}
                  {item.currency}
                </TableCell>
                <TableCell className={classes.cell}>
                  <Button
                    className={
                      item.status === 'PAID'
                        ? classes.btnPaySuccess
                        : classes.paymentBtn
                    }
                    disabled={item.status === 'PAID'}
                    component="a"
                    href={`${process.env.REACT_APP_API_PATH_PAYMENT_URL}/cart/checkout/payment/${item.idConcept}/${item.idProgram}/${item.idUserPayment}`}
                  >
                    {item.status !== 'PAID' ? 'Pagar' : 'Pagado'}
                  </Button>
                  {item.status === 'PAID' && (
                    <RowMenu
                      urlProduct={item.urlProduct}
                      isBilling={item.isBilling}
                      idUserPayment={item.idUserPayment}
                      send={item.send}
                    />
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

DataTable.propTypes = {
  // eslint-disable-next-line react/require-default-props
  data: PropTypes.data,
  // eslint-disable-next-line react/require-default-props
  charges: PropTypes.bool
};

export default DataTable;
